"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetFactory = void 0;
var PromiEvent_1 = __importDefault(require("../utils/PromiEvent"));
var contracts_1 = require("./contracts");
var APENFT721_json_1 = __importDefault(require("../abi/APENFT721.json"));
var helper_1 = require("../utils/helper");
function getConstructorAbi(abi) {
    return abi.find(function (a) { return a.type === 'constructor'; });
}
var AssetFactory = /** @class */ (function (_super) {
    __extends(AssetFactory, _super);
    function AssetFactory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.contracts = {};
        return _this;
    }
    AssetFactory.prototype.contract721 = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!this.contracts[address]) return [3 /*break*/, 2];
                        _a = this.contracts;
                        _b = address;
                        return [4 /*yield*/, this.web3.contract(APENFT721_json_1.default.abi, address)];
                    case 1:
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [2 /*return*/, this.contracts[address]];
                }
            });
        });
    };
    AssetFactory.prototype.balanceOf = function (address, account) {
        return __awaiter(this, void 0, void 0, function () {
            var contract;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contract721(address)];
                    case 1:
                        contract = _a.sent();
                        return [4 /*yield*/, contract.balanceOf(account).call()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Deploy the ERC721 contract and return the contract address
     * @param name
     * @param symbol
     * @param baseUrl
     * @returns Promise
     */
    AssetFactory.prototype.createAsset721x = function (name, symbol, baseUrl) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.factoryContract.createERCAsset(symbol, name, baseUrl)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Deploy the ERC721 contract and return the contract address
     * @param {string} name - contract name
     * @param {string} symbol - contract symbol
     * @param {string} baseUrl - contract metadata json url
     * @param {object} [options]  - options，see https://cn.developers.tron.network/reference/tronweb-createsmartcontract
     * @returns {Promise<{txHash,txSend}>}  Promise object
     */
    AssetFactory.prototype.createAsset721 = function (name, symbol, baseUrl, options) {
        return __awaiter(this, void 0, void 0, function () {
            var defaultOptions, opts, transaction, signedTransaction, broadcast, defer, err;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        defaultOptions = {
                            shouldPollResponse: true,
                            feeLimit: 1e9,
                            callValue: 0,
                            userFeePercentage: 30,
                            originEnergyLimit: 1e7
                        };
                        options = Object.assign({}, defaultOptions, options);
                        opts = {
                            abi: APENFT721_json_1.default.abi,
                            bytecode: APENFT721_json_1.default.bytecode,
                            feeLimit: options.feeLimit,
                            callValue: options.callValue,
                            userFeePercentage: options.userFeePercent,
                            originEnergyLimit: options.originEnergyLimit,
                            name: 'APENFT721',
                            parameters: [symbol, name, baseUrl, this.erc721AssetProxyAddr],
                            permissionId: 0 //options, Owner id=0, Witness id=1, The Active id is incremented from 2 and is used for multiple signatures. If this parameter is missing, TronLink for iphone will report an error
                        };
                        return [4 /*yield*/, this.web3.transactionBuilder.createSmartContract(opts, this.web3.defaultAddress.hex)];
                    case 1:
                        transaction = _a.sent();
                        return [4 /*yield*/, this.web3.trx.sign(transaction)];
                    case 2:
                        signedTransaction = _a.sent();
                        if (!signedTransaction.signature) {
                            return [2 /*return*/, Promise.reject('Transaction was not signed properly')];
                        }
                        return [4 /*yield*/, this.web3.trx.sendRawTransaction(signedTransaction)];
                    case 3:
                        broadcast = _a.sent();
                        defer = (0, PromiEvent_1.default)();
                        if (broadcast.code) {
                            err = {
                                error: broadcast.code,
                                message: broadcast.code
                            };
                            if (broadcast.message)
                                err.message = this.web3.toUtf8(broadcast.message);
                            defer.reject(err);
                            return [2 /*return*/, Promise.reject(err)];
                        }
                        if (!(options === null || options === void 0 ? void 0 : options.shouldPollResponse)) {
                            defer.resolve(signedTransaction.txID);
                            defer.eventEmitter.emit('transactionHash', signedTransaction.txID);
                            return [2 /*return*/, Promise.resolve({ txHash: signedTransaction.txID, txSend: defer.eventEmitter })];
                        }
                        (0, helper_1.checkResultFast)(0, this.web3, defer, signedTransaction);
                        return [2 /*return*/, Promise.resolve({ txHash: signedTransaction.txID, txSend: defer.eventEmitter })];
                }
            });
        });
    };
    /**
     * @deprecated use createAsset721
     * contract().new(options) will return "Invalid issuer address provided"
     */
    AssetFactory.prototype.deployAsset721 = function (name, symbol, baseUrl, options) {
        return __awaiter(this, void 0, void 0, function () {
            var defaultOptions, opts, contract_instance, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        defaultOptions = {
                            shouldPollResponse: true,
                            feeLimit: 1e9,
                            callValue: 0,
                            userFeePercentage: 30,
                            originEnergyLimit: 1e7
                        };
                        options = Object.assign({}, defaultOptions, options);
                        opts = {
                            abi: APENFT721_json_1.default.abi,
                            bytecode: APENFT721_json_1.default.bytecode,
                            feeLimit: options.feeLimit,
                            callValue: options.callValue,
                            userFeePercentage: options.userFeePercent,
                            originEnergyLimit: options.originEnergyLimit,
                            name: 'APENFT721',
                            parameters: [symbol, name, baseUrl, this.erc721AssetProxyAddr]
                            // permissionId: 0
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.web3.contract().new(opts)];
                    case 2:
                        contract_instance = _a.sent();
                        return [2 /*return*/, Promise.resolve(contract_instance)];
                    case 3:
                        e_1 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_1)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     *
     * @param {string} assetAddr - NFT contract address
     * @param {string} to - NFT token  receiver address
     * @param {string} [url] - options ，NFT metadata baseUrl
     * @returns Promise
     */
    AssetFactory.prototype.mint721 = function (assetAddr, to, url) {
        return __awaiter(this, void 0, void 0, function () {
            var defer, assetContract, txID, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        defer = (0, PromiEvent_1.default)();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.contract721(assetAddr).catch(function (err) {
                                defer.eventEmitter.emit('error', err);
                            })];
                    case 2:
                        assetContract = _a.sent();
                        return [4 /*yield*/, assetContract
                                .mintTo(to, url || '')
                                .send()
                                .catch(function (err) {
                                defer.eventEmitter.emit('error', err);
                            })
                            // user reject sign
                        ];
                    case 3:
                        txID = _a.sent();
                        // user reject sign
                        if (!txID) {
                            return [2 /*return*/, Promise.reject('Transaction was not signed properly')];
                        }
                        defer.eventEmitter.emit('transactionHash', txID);
                        (0, helper_1.checkResultFast)(0, this.web3, defer, { txID: txID });
                        return [2 /*return*/, Promise.resolve({ txHash: txID, txSend: defer.eventEmitter })];
                    case 4:
                        err_1 = _a.sent();
                        defer.eventEmitter.emit('error', err_1);
                        return [2 /*return*/, Promise.resolve({ txHash: '', txSend: defer.eventEmitter })];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return AssetFactory;
}(contracts_1.Contracts));
exports.AssetFactory = AssetFactory;
